<body class="ltr main-body leftmenu">
    <!-- -->
    <form autocomplete="off" class="p-0" novalidate [formGroup]="examInputForm">
        <!-- Main Content-->
        <div class="main-content side-content">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <!-- <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">{{'header.exam-data.titleList.AllRecords'|
                                translate}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">{{'header.exam-data.titleList.Data'|
                                    translate}}
                                </li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                               
                            </div>
                        </div>
                    </div> -->

                    <!-- list of Cource end  -->
                    <!-- add of Exam start  -->
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">

                                <div class="card-body">
                                    <div class=" d-flex align-items-center pl-3">
                                        <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                                        <div class="ml-2">
                                            <h3 class="main-content-label mb-1"><b>
                                                    {{'header.exam-data.table.AllRecords'|
                                                    translate}}
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                               Exam Form
                                            </p>
                                        </div>
                                    </div>
                                    <hr class="mt-1 mb-2">
                                    <!-- <div>
                                            <h2 class="main-content-title tx-24 mg-b-5">{{'header.exam-data.titleList.AllRecords'|
                                                translate}}</h2>
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item active">{{'header.exam-data.titleList.Data'|
                                                    translate}}
                                                </li>
                                            </ol>
                                        </div> -->
                                    <!-- <div *ngIf="submitButton">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.exam-data.titleList.AddNewRecord'|
                                                    translate}}</b>
                                            </h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{'header.exam-data.titleList.AddNewInfo'| translate}}</p>
                                        </div>
                                        <div *ngIf="editButton">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.exam-data.titleList.UpdateRecord'|
                                                    translate}}</b>
                                            </h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{'header.exam-data.titleList.UpdateSelectedInfo'|
                                                translate}}</p>
                                        </div> -->
                                    <div class="row clearfix mt-3">

                                        <div class="col-md-3">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label> List No </mat-label>
                                                <mat-select formControlName="EcId" #select23 class="colorblack"
                                                    required>
                                                    <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'ListDesc'" [array]="ListOfReg"
                                                        (filteredReturn)=" filteredListOfReg =$event">
                                                    </mat-select-filter>
                                                    <mat-option *ngFor="let item of  filteredListOfReg"
                                                        [value]="item.EcId" (click)="selectedList(item)">
                                                        {{item.ListDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="examInputForm.controls['EcId'].touched && examInputForm.controls['EcId'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <input formControlName="SCgCode" [readonly] ="isCollege"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" placeholder="College" id="EmSrNo" matInput>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-sm-3 mt-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-sm-3">
                                                                <mat-label class="mt-1 lclass"><span
                                                                        class="-asterisk mr-1"></span>Valid
                                                                </mat-label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <mat-radio-group onkeydown="return (event.keyCode!=13);"
                                                                    id="EmStreams" formControlName="SValid"  class="example-full-width">
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <mat-radio-button value='Y'>Yes
                                                                            </mat-radio-button>
                                                                        </div>
                                                                        <div class="col-sm-5">
                                                                            <mat-radio-button value='N'>No
                                                                            </mat-radio-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-radio-group>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-sm-3">
                                                                <mat-label class="mt-1 lclass"><span
                                                                        class="-asterisk mr-1"></span>App
                                                                </mat-label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <mat-radio-group onkeydown="return (event.keyCode!=13);"
                                                                    id="EmStreams" formControlName="SApp"  class="example-full-width">
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <mat-radio-button value='Y'>Yes
                                                                            </mat-radio-button>
                                                                        </div>
                                                                        <div class="col-sm-5">
                                                                            <mat-radio-button value='N'>No
                                                                            </mat-radio-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-radio-group>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-sm-4">
                                                                <mat-label class="mt-1 lclass"><span
                                                                        class="-asterisk mr-1"></span>Change
                                                                </mat-label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <mat-radio-group onkeydown="return (event.keyCode!=13);"
                                                                    id="EmStreams" formControlName="SChng"  class="example-full-width">
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <mat-radio-button value='Y'>Yes
                                                                            </mat-radio-button>
                                                                        </div>
                                                                        <div class="col-sm-5">
                                                                            <mat-radio-button value='N'>No
                                                                            </mat-radio-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-radio-group>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div> -->
                                        <div class="col-sm-3">
                                            <div class="form-group">

                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Valid</mat-label>
                                                    <mat-select formControlName="SValid" #select104 class="colorblack">
                                                        <mat-option>Select</mat-option>
                                                        <mat-option value="N">No</mat-option>
                                                        <mat-option value="Y">Yes</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">

                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> App</mat-label>
                                                    <mat-select formControlName="SApp" #select104 class="colorblack">
                                                        <mat-option>Select</mat-option>
                                                        <mat-option value="N">No</mat-option>
                                                        <mat-option value="Y">Yes</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">

                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Changed</mat-label>
                                                    <mat-select formControlName="SChng" #select104 class="colorblack">
                                                        <mat-option>Select</mat-option>
                                                        <mat-option value="N">No</mat-option>
                                                        <mat-option value="Y">Yes</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-12 prpl">
                                                <button type="button"
                                                    class="btn btn-primary btn-icon-text floatright mt-1"
                                                    (click)="searchExams()">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/search.gif"
                                                            style="margin-right: 5px;">
                                                        Search
                                                    </span>
                                                </button>
                                                <!-- <button type="button" (click)="print()" class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="15vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                        Print
                                                    </span>
                                                </button> -->
                                                <button type="button"
                                                    class="btn btn-primary btn-icon-text floatright mr-3 mt-1"
                                                    (click)="generateExams()">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/save.gif"
                                                            style="margin-right: 7px;">
                                                        Generate
                                                    </span>
                                                </button>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row clearfix" *ngIf="show">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Registration Number
                                                        </mat-label>
                                                        <input formControlName="RgNo"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" maxlength="80" placeholder="Registration Number"
                                                            id="EmName" matInput>
                                                        <!--  <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmName'].touched && ExamForm.controls['EmName'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <input formControlName="CgName"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" placeholder="College Name" matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                   Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            Branches
                                                        </mat-label>
                                                        <!-- <input maxlength="20" formControlName="strName"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" placeholder="Branch Name" id="EmShName"
                                                            matInput> -->
                                                        <mat-select #select28 placeholder="" class="colorblack"
                                                            formControlName="strCode">
                                                            <mat-select-filter *ngIf="select28.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrName'"
                                                                [array]="streamList"
                                                                (filteredReturn)="filteredStreamList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredStreamList"
                                                                [value]="item.StrCode" (click)="getSub(item.StrId,item.StrCode)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Name
                                                        </mat-label>
                                                        <input formControlName="RgName"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" maxlength="80" placeholder="Student Name"
                                                            matInput>
                                                        <!--  <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmName'].touched && ExamForm.controls['EmName'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            Category
                                                        </mat-label>
                                                        <input formControlName="Cate"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" placeholder="Category add select" matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3 mt-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="-asterisk mr-1"></span>App
                                                            </mat-label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <mat-radio-group formControlName="App"
                                                                onkeydown="return (event.keyCode!=13);" id="EmStreams"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-5">
                                                                        <mat-radio-button value='Y'>Yes
                                                                        </mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-5">
                                                                        <mat-radio-button value='N'>No
                                                                        </mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">  
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>OptSub</mat-label>
                                                <mat-select multiple #select29 placeholder="" class="colorblack"
                                                            formControlName="OptSub">
                                                            <mat-select-filter *ngIf="select29.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredSubjectList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredSubjectList"
                                                                [value]="item.EsCode">
                                                                {{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <!-- <div class="col-md-1">
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text btn-raised g-bg-blush2">
                                                    Add</button>
                                            </div>
                                            <div class="col-md-3">
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text btn-raised g-bg-blush2">
                                                    Remove</button>
                                            </div> -->
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            RPV 0/1
                                                        </mat-label>
                                                        <input onkeydown="return (event.keyCode!=13);"
                                                            style="color:black;" type="text" placeholder="Exam Code"
                                                            matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Declare</mat-label>
                                                <mat-select #select3 class="colorblack" id="EmCoCode">
                                                    <mat-select-filter *ngIf="select3.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CoCode'" [array]="CourseList"
                                                        (filteredReturn)="filteredListCourse =$event">
                                                    </mat-select-filter>
                                                    <mat-option onkeydown="return (event.keyCode!=13);"
                                                        *ngFor="let item of filteredListCourse" [value]="item.CoCode">
                                                        {{item.CoCode}}
                                                    </mat-option>
                                                </mat-select>
                                                <!--  <mat-error class="margin_tp"
                                                            *ngIf="ExamForm.controls['EmCoCode'].touched && ExamForm.controls['EmCoCode'].errors?.">
                                                           Mandatory
                                                        </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            Center
                                                        </mat-label>
                                                        <input formControlName="Cent"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" placeholder="Exam Code" matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                   Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            Pre Center
                                                        </mat-label>
                                                        <input formControlName="PrefCent"
                                                            onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                            type="text" placeholder="Exam Code" matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            Roll No
                                                        </mat-label>
                                                        <input onkeydown="return (event.keyCode!=13);"
                                                            style="color:black;" type="text" placeholder="Exam Code"
                                                            matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width ">
                                                        <mat-label>
                                                            Valid
                                                        </mat-label>
                                                        <input onkeydown="return (event.keyCode!=13);"
                                                            style="color:black;" type="text" placeholder="Exam Code"
                                                            matInput>
                                                        <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.">
                                                                    Mandatory
                                                                </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">  
                                            <!-- <div>Subjects</div>
                                            <div  class="table-responsive table-container tab mt-1">
                                                
                                                <table class="table table-bordered text-nowrap">
                                                    <thead class="thZindex">
                                                        <tr>
                                                            <th class="hidden">

                                                            </th>
                                                            <th class="hidden">

                                                            </th>
                                                            <th class="f600">
                                                                Type
                                                            </th>
                                                            <th class="f600">
                                                             Subject
                                                            </th>
                                                            <th class="f600">
                                                               Head
                                                            </th>
                                                            <th class="f600">
                                                               Pass
                                                            </th>
                                                            <th class="f600 tab3">
                                                               Appr
                                                            </th>
                                                            <th class="f600">
                                                               NewSub
                                                            </th>
                                                            <th class="f600">
                                                                Marks
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="SubArray">
                                                        <tr *ngFor="let subData of getSubArrayControls(); let i = index"
                                                        [formGroupName]="i">
                                                            <td class="hidden">
                                                                <input readonly class="tab2"
                                                                formControlName="EsId">
                                                            </td>
                                                            <td class="hidden">
                                                                <input readonly class="tab2"
                                                                formControlName="SrNo">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2"
                                                                formControlName="EsType">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2"
                                                                formControlName="Sub">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2"
                                                                formControlName="Head">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2"
                                                                formControlName="Pass">
                                                            </td>
                                                            <td>
                                                                
                                                                <mat-select *ngIf="subData.get('showDropdown').value" formControlName="App">
                                                                    <mat-option value="Y">
                                                                        Y
                                                                    </mat-option>
                                                                    <mat-option value="N">
                                                                        N
                                                                    </mat-option>
                                                                </mat-select>
                                                                
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2"
                                                                formControlName="NewSub">
                                                                
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2"
                                                                formControlName="Marks">
                                                                
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div> -->
                                            
                                                <div>Subjects</div>
                                                <div  class="table-responsive table-container tab mt-1">
                                                    
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead class="thZindex">
                                                            <tr>
                                                                <th class="hidden">

                                                                </th>
                                                                <th class="hidden">

                                                                </th>
                                                                <th class="f600">
                                                                    Type
                                                                </th>
                                                                <th class="f600">
                                                                 Subject
                                                                </th>
                                                                <th class="f600">
                                                                   Head
                                                                </th>
                                                                <th class="f600">
                                                                   Pass
                                                                </th>
                                                                <th class="f600 tab3 hidden" >
                                                                   Appr
                                                                </th>
                                                                <th class="f600">
                                                                    Comments
                                                                 </th>
                                                                <th class="f600">
                                                                   NewSub
                                                                </th>
                                                                <!-- <th class="f600 hidden">
                                                                    Marks
                                                                </th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody id="table_data" formArrayName="SubArray" >
                                                            <ng-container *ngFor="let subData of getSubArrayControls(); let i = index">
                                                                <tr [formGroupName]="i" *ngIf="isVisible(subData)">
                                                                    <td class="hidden">
                                                                        <input readonly class="tab2"
                                                                        formControlName="EsId">
                                                                    </td>
                                                                    <td class="hidden">
                                                                        <input readonly class="tab2"
                                                                        formControlName="SrNo">
                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="tab2"
                                                                        formControlName="EsType">
                                                                        <!-- {{subData.EsType}} -->
                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="tab2"
                                                                        formControlName="Sub">
                                                                       <!-- {{subData.Sub}} -->
                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="tab2"
                                                                        formControlName="Head">
                                                                       <!-- {{subData.Head}} -->
                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="tab2"
                                                                        formControlName="Pass">
                                                                    </td>
                                                                    <td class="hidden">
                                                                        <mat-select [disabled]="checkvalidattion(subData,i)" *ngIf="subData.get('showDropdown').value" 
                                                                       formControlName="App">
                                                                            <mat-option value="Y">
                                                                                Y 
                                                                            </mat-option>
                                                                            <mat-option value="N">
                                                                                N
                                                                            </mat-option>
                                                                        </mat-select>
                                                                        <mat-error class="margin_tp mrgtp" *ngIf="subData.get('App').hasError('mandatory') && subData.get('App').touched">
                                                                            Mandatory
                                                                          </mat-error>
                                                                        
                                                                    </td>
                                                                    <td>
                                                                        
                                                                            <p><b class="red"
                                                                                    *ngIf="isAttendanceDeficient(subData)">Attendance
                                                                                    is deficient</b></p>
                                                                        
                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="tab2"
                                                                        formControlName="NewSub">
                                                                        <!-- {{subData.NewSub}} -->
                                                                    </td>
                                                                    <!-- {{subData.Marks}} -->
                                                                    <!-- <td>
                                                                        <input readonly class="tab2 hidden"
                                                                        formControlName="Marks">
                                                                        
                                                                    </td> -->
                                                                </tr>
                                                            </ng-container>
                                                            
                                                        </tbody>
                                                    </table>
                                                </div>
                                            
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <button type="button"
                                                        class="btn sz btn-primary btn-icon-text floatright mt-1 mb-3 fr"
                                                        (click)="Generate()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 5px;">
                                                            Save
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        
                                        <!-- <div class="col-sm-12">
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="submitButton">{{'header.exam-data.titleList.Submit'|
                                                    translate}}</button>
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="editButton">{{'header.exam-data.titleList.Update'|
                                                    translate}}</button>
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-raised g-bg-blush2">
                                                    Delete</button>

                                                <button type="button"
                                                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base">{{'header.exam-data.titleList.Back'|
                                                    translate}}</button>

                                            </div> -->

                                        

                                    </div>
                                    <!-- <hr> -->
                                    <div class="table-responsive" *ngIf="ShowTbl">
                                        <table id="datatable" class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        SrNo
                                                    </th>
                                                    <th class="f600">
                                                        RgNo
                                                    </th>
                                                    <th class="f600">
                                                        EmId
                                                    </th>
                                                    <th class="f600">
                                                        RgName
                                                    </th>
                                                    <th class="f600 text-center">
                                                        CgCode
                                                    </th>
                                                    <th class="f600">
                                                        Valid
                                                    </th>
                                                    <th class="f600">
                                                        Message
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <!-- *ngFor="let exam of examList;" -->
                                                <tr *ngFor="let exam of examList;let i = index" (click)="prepopulate(exam)">
                                                    <td>{{i+1}}</td>
                                                    <td>{{exam.RgNo}} </td>
                                                    <td>{{exam.EmId}} </td>
                                                    <td>{{exam.RgName}} </td>
                                                    <td>{{exam.CgCode}} </td>
                                                    <td>{{exam.Valid}} </td>
                                                    <td>{{exam.Mesg}}</td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <!-- <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                   

                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>